import { convert, HtmlToTextOptions } from "html-to-text";

export function parseTeamsMessage(html: string | null | undefined) {
  if (!html) return { plainText: "", gifAttachments: [], hasVideo: false };
  const gifAttachments: string[] = [];
  let hasVideo = false;
  const options: HtmlToTextOptions = {
    wordwrap: false,
    formatters: {
      teamsParser: (elem, walk, builder) => {
        const attribs = elem.attribs || {};
        const src = attribs.src;
        const alt = attribs.alt;
        const tagName = elem.name;
        const itemType = attribs.itemtype || "";
        if (itemType.includes("Emoji") && alt) {
          builder.addInline(`${alt}`);
          return;
        }

        if (tagName === "video") {
          hasVideo = true;
          return;
        }

        if (src && src.includes("giphy.com")) {
          gifAttachments.push(src);
          return;
        }

        if (tagName === "img" && src?.includes("hostedContents")) {
          hasVideo = true;
          return;
        }
      },
    },
    selectors: [
      { selector: "video", format: "teamsParser" },
      {
        selector: "img",
        format: "teamsParser",
      },
    ],
  };

  const plainText = convert(html, options);

  return { plainText, gifAttachments, hasVideo };
}
